<div class="row">
    <div class="col-12">
  
        <p>Please enter the username associated with your account. We will send you an email containing
        a link to verify your email.</p>
    
        <div id="emailLinkSentAlert" class="alert alert-success mb-4 py-4" role="alert" *ngIf="emailLinkSent"
            [@showEmailLinkSentMessage]>
            
            <p>If the username you entered is associated with an email address, we will send an email containing your verification link.</p>
            
            <p>Please click the link in the email, or copy and paste the link into your browser to verify your email address.</p>
            
            <p class="ml-auto">Not seeing an email? Please contact us at {{ customerServicePhone }}.</p>

        </div>
        
    
        <div id="genericErrorAlert" class="alert alert-danger mb-4 py-4" role="alert" *ngIf="genericErrorAlertShown"
            [@showGenericErrorAlert]>
            <p>We encountered an issue completing your request.</p>
            <span class="alert-span">Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
        </div>
    
        <form id="verifyEmailForm" class="mb-2" [formGroup]="verifyEmailForm" (ngSubmit)="sendEmailLink()">
    
            <div class="form-group form-label-group">
                <input id="usernameInput" formControlName="usernameInput" class="form-control" placeholder="Enter Username"
                    [ngClass]="{ 'is-invalid': sendEmailLinkButtonClicked && verifyEmailForm.controls.usernameInput.errors }">
                <label for="emailInput">Enter Username</label>
                <div *ngIf="sendEmailLinkButtonClicked && verifyEmailForm.controls.usernameInput.errors" class="invalid-feedback">
                    <div *ngIf="verifyEmailForm.controls.usernameInput.errors.required">Username is required.</div>
                </div>
            </div>
    
            <div class="row">
            <div class="col-12 d-flex">
                <button type="submit" form="verifyEmailForm"
                        class="btn rounded-pill bg-secondary ml-auto text-white px-4 py-2">
                <span class="font-weight-bold">Send Verification Email</span>
                </button>
            </div>
            </div>
        </form>

    </div>
</div>
  